<template>
	<div class="box">
		<i @click="handleClickPlus" class="icon icon-audit-add-2x"></i>
	</div>
</template>

<script>
export default {
	name: 'plus',
	data () {
		return {

		}
	},
	components: {},
	created(){},
	watch: {},
	computed: {},
	mounted(){},
	methods: {
		handleClickPlus() {
			this.$emit('handleClickFlowPlus')
		}
	},
	beforeDestroy(){}
}
</script>

<style scoped>
.box {
	position: relative;
	margin: 10px 10px 0 0;
	width: 80px;
	float: left;
	text-align: center;
}

.box i {
	width: 50px;
	height: 50px;
	margin: 5px;
	cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// components/flow/Plus.vue